<template>
  <div class="wxPayQrCode">
    <a class="qrCodeA" href="javascript: void(0)" @click="handleRefresh">
      <div id="qrCode" class="qrCode"></div>
      <div class="qrCodeMask" v-show="qrCodeMaskVisible">
        <i class="el-icon-refresh"></i>
        <span>二维码已过期,点击刷新</span>
      </div>
    </a>
  </div>
</template>

<script>
import API from "@/../config/api";
import QRCode from 'qrcodejs2';
import { Message } from 'element-ui';
export default {
  name: "wxPayQrCode",
  props: {qrCodeParams: Object},
  data() {
    return {
      queryTime: 0,
      qrCodeMaskVisible: false,
      timeInt: null,
    }
  },
  created() {
    this.$bus.$on('to-show-qrcode', () => {
      this.newCode()
    })
  },
  beforeDestroy() {
    clearTimeout(this.timeInt)
    this.$bus.$off('to-show-qrcode')
  },
  destroyed() {

  },
  methods: {
    newCode() {
      this.qrCodeMaskVisible = false;
      this.queryTime = 0
      document.getElementById("qrCode").innerHTML = "";
      var qrcode = new QRCode(document.getElementById("qrCode"));
      qrcode.makeCode(this.qrCodeParams.code_url);
      if (this.timeInt)
        window.clearTimeout(this.timeInt);//生成定时器之前删除上一个定时器
      this.timeInt = setTimeout(() => {
        let that = this
        console.log(that)
        this.wXOrderStatus();
      }, 2000)
    },
    /**
     * 提示WX支付进度信息*/
    async wXOrderStatus() {
      this.queryTime++;
      if(this.queryTime > 30) {
        this.qrCodeMaskVisible = true
        return;
      }
      let data = await this.$axiosRequest({
        url: API.wXOrderStatus,
        method: "GET",
        data: {
          out_trade_no: this.qrCodeParams.out_trade_no,
          attach: this.qrCodeParams.attach
        }
      })
      data = data[1].data;
      if (data.trade_state === "SUCCESS") {
        Message({
          type: 'success',
          message: data.trade_state_desc
        });
        this.$bus.$emit('wx-pay-success');
      } else {
        this.timeInt = setTimeout(() => {
          let that = this
          console.log(that.qrCodeParams.out_trade_no)
          this.wXOrderStatus();
        }, 2000)
      }
    },
    handleRefresh() {
      this.$bus.$emit('qrcode-refresh')
    }
  }
}
</script>

<style lang="less">
  .wxPayQrCode{
    .qrCodeA {
      margin: 0 auto;
      width: 256px;
      height: 256px;
      display: block;
      position: relative;
    }
    #qrCode {
      z-index: -999;
      img {
        margin: 0 auto;
      }
    }

    .qrCodeMask {
      z-index: 999;
      display: inline-block;
      height: 256px;
      width: 256px;
      position: absolute;
      left: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.8);
      color: white;
      font-size: 72px;
      //line-height: 150px;
      text-align: center;
      span {
        display: block;
        position: relative;
        font-size: 14px;
        top: 85px;
      }
      i {
        display: block;
        position: relative;
        top: 60px;
      }
    }
  }

</style>